// extracted by mini-css-extract-plugin
module.exports = {"approvalContainer":"AdminSettingsAddApprovalContainer_approvalContainer__2YHFh","title":"AdminSettingsAddApprovalContainer_title__gZu_d"};